export const API_KEY_MAP = "AIzaSyDTq_sQ0ZCmTnI6A3l3VD_UD9FvkBAhpoQ";
